import script from "./phasing-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./phasing-button.vue?vue&type=script&setup=true&lang=ts"

import "./phasing-button.vue?vue&type=style&index=0&id=2d9c3506&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9c3506"]])

export default __exports__